<template>
  <BaseAlert class="tw-p-3 tw-mt-2" theme="danger">
    There are no leave types available for you to request. Please contact your
    administrator to make one available.
  </BaseAlert>
</template>

<script>
import BaseAlert from '@/components/BaseAlert'

export default {
  name: 'NoRequestableLeaveTypesError',
  components: {
    BaseAlert,
  },
}
</script>
